import { combineReducers } from 'redux';
import login from './loginReducers';
import common from './commonReducers';

const rootReducer = combineReducers({ login, common });

export default rootReducer;
